// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.follow-button {
    font-weight: 600;
    text-decoration: none;
    color: #2E3F89;
    font-family: sans-serif;
    cursor: pointer;
}

.follow-button:hover {
    opacity: 0.8;
}

.follow-button-grid {
    font-size: 12px;
    margin-left: 7%;
    margin-right: 4%;
}

.follow-button-flyout {
    font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/grid/FollowButton.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".follow-button {\n    font-weight: 600;\n    text-decoration: none;\n    color: #2E3F89;\n    font-family: sans-serif;\n    cursor: pointer;\n}\n\n.follow-button:hover {\n    opacity: 0.8;\n}\n\n.follow-button-grid {\n    font-size: 12px;\n    margin-left: 7%;\n    margin-right: 4%;\n}\n\n.follow-button-flyout {\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
